export const PHASE3_PRODUCT_SCOPES = {
  STUDIO               : 'studio',
  APPRAISAL_NEEDED    : 'appraisal_needed',
  CONFIRM_BUYING_PRICE : 'confirm_buying_price',
  APPRAISAL_APPROVAL   : 'appraisal_approval',
  APPRAISAL_DONE       : 'appraisal_done',
  PRICE_TAG            : 'price_tag',
  READY_TO_LIVE        : 'ready_to_live',
  READY_FOR_INBOUND    : 'ready_for_inbound',
  WAITING_FOR_INBOUND  : 'waiting_for_inbound',
  INBOUND_COMPLETED    : 'inbound_completed',
  LIVE                 : 'live',
  DELETED              : 'deleted',
  UNPROCESSED          : 'unprocessed',
  INCOMING             : 'incoming',
  BKT                  : 'bkt'
}

export const PHASE3_SCOPE_LABELS = {
  [PHASE3_PRODUCT_SCOPES.STUDIO]               : 'Studio Check',
  [PHASE3_PRODUCT_SCOPES.APPRAISAL_NEEDED]    : 'Appraisal Needed',
  [PHASE3_PRODUCT_SCOPES.CONFIRM_BUYING_PRICE] : 'Confirm Buying Price',
  [PHASE3_PRODUCT_SCOPES.APPRAISAL_APPROVAL]   : 'Appraisal Approval',
  [PHASE3_PRODUCT_SCOPES.APPRAISAL_DONE]       : 'Appraisal Done',
  [PHASE3_PRODUCT_SCOPES.PRICE_TAG]            : 'Price Tag + Final Check',
  [PHASE3_PRODUCT_SCOPES.READY_TO_LIVE]        : 'Ready To Live',
  [PHASE3_PRODUCT_SCOPES.READY_FOR_INBOUND]    : 'Ready For Inbound',
  [PHASE3_PRODUCT_SCOPES.WAITING_FOR_INBOUND]  : 'Waiting For Inbound',
  [PHASE3_PRODUCT_SCOPES.INBOUND_COMPLETED]    : 'Completed',
  [PHASE3_PRODUCT_SCOPES.LIVE]                 : 'Live',
  [PHASE3_PRODUCT_SCOPES.DELETED]              : 'Deleted',
  [PHASE3_PRODUCT_SCOPES.UNPROCESSED]          : 'Unprocessed',
  [PHASE3_PRODUCT_SCOPES.INCOMING]             : 'Incoming',
  [PHASE3_PRODUCT_SCOPES.BKT]                  : 'BKT'
}

export const PHASE3_OUTBOUND_AUTH_STATES = [
  'pending',
  'passed',
  'failed',
  'skipped'
]

export const PHASE3_PROCESS_STEPS = [
  {
    number: 1,
    title: 'Sales Assistant / Product Curator Create Consign',
    owner: 'SA + Product Curator',
    route: '/app/inbound-journey/create-intake',
    description: 'Create 1 consignment for 1 or many products, then use Inventory Batch for physical handover.'
  },
  {
    number: 2,
    title: 'Studio Check + Photo Details',
    owner: 'Studio Team',
    route: '/app/inbound-journey/studio',
    description: 'Double-check product condition, complete Dashboard photo details, and mark original Google Drive upload.'
  },
  {
    number: 3,
    title: 'Appraisal Needed',
    owner: 'Curator Team',
    route: '/app/inbound-journey/appraisal-needed',
    description: 'Fill buying/default/selling price and negotiation notes.'
  },
  {
    number: 4,
    title: 'Confirm Buying Price / HM',
    owner: 'Finance Team',
    route: '/app/inbound-journey/confirm-buying-price',
    description: 'Finance confirms buying price before approval.'
  },
  {
    number: 5,
    title: 'Appraisal Approval',
    owner: 'Curator Team',
    route: '/app/inbound-journey/appraisal-approval',
    description: 'Curator approves or rejects appraisal.'
  },
  {
    number: 6,
    title: 'Price Tag + Final Check',
    owner: 'Inbound Team',
    route: '/app/inbound-journey/price-tag',
    description: 'Print price tag/barcode, then final-check price_tag_done, description, comes with, and defects.'
  },
  {
    number: 7,
    title: 'Ready To Live',
    owner: 'Inbound Team',
    route: '/app/inbound-journey/ready-to-live',
    description: 'Use Inventory Batch / consignment bulk-live once every ready product has passed final check.'
  },
  {
    number: 8,
    title: 'Outbound Authentication After Deal',
    owner: 'Outbound Team',
    route: '/app/inbound-journey/outbound-authentication',
    description: 'Authenticate product after customer deal and before shipment.'
  }
]

// Phase 3 July 20 access configuration
export const PHASE3_JULY20_APPRAISAL_CATEGORIES = [ 'H', 'W', 'C' ]

export const PHASE3_JULY20_APPRAISAL_CATEGORY_LABELS = {
  H: 'H — Hermes',
  W: 'W — Watch',
  C: 'C — Curated'
}

export const PHASE3_JULY20_FIXED_CATEGORY_EMAILS = {
  'angel@belleandkate.com': 'C',
  'jac@belleandkate.com': 'H'
}

export const PHASE3_JULY20_APPRAISAL_EMAILS = [
  'angel@belleandkate.com',
  'jac@belleandkate.com',
  'mifta.belleandkate@gmail.com'
]

export const PHASE3_JULY20_CREATE_CONSIGN_EMAILS = [
  'angel@belleandkate.com',
  'jac@belleandkate.com'
]

export const PHASE3_JULY20_APPRAISAL_NEEDED_ROLES = [
  'owner',
  'admin',
  'product_curated',
  'web',
  'stc',
  'finance',
  'purchasing'
]

export const PHASE3_JULY20_APPRAISAL_APPROVAL_ROLES = [
  'owner',
  'admin'
]

export const PHASE3_JULY20_APPRAISAL_APPROVAL_EMAILS = [
  'mifta.belleandkate@gmail.com',
  'angel@belleandkate.com'
]

export const PHASE3_JULY20_CF_BUYING_PRICE_ROLES = [ 'owner' ]
export const PHASE3_JULY20_CF_BUYING_PRICE_EMAILS = [
  'mifta.belleandkate@gmail.com',
  'hayu@belleandkate.com',
  'rahayu@belleandkate.com',
  'angel@belleandkate.com'
]

export const normalizePhase3July20Role = (value) => value
  ?.toString()
  .trim()
  .toLowerCase()
  .replace(/\s+/g, '_') || ''

export const normalizePhase3July20Email = (value) => value
  ?.toString()
  .trim()
  .toLowerCase() || ''

export const phase3July20FixedCategoryForUser = (user = {}) => {
  return PHASE3_JULY20_FIXED_CATEGORY_EMAILS[normalizePhase3July20Email(user.email)] || ''
}

export const phase3July20ShowCategoryDropdown = (user = {}) => {
  const role = normalizePhase3July20Role(user.role)
  const email = normalizePhase3July20Email(user.email)

  if (PHASE3_JULY20_FIXED_CATEGORY_EMAILS[email]) return false

  return [ 'owner', 'purchasing' ].includes(role) || email === 'mifta.belleandkate@gmail.com'
}

export const phase3July20CanViewAppraisalNeeded = (user = {}) => {
  const role = normalizePhase3July20Role(user.role)
  const email = normalizePhase3July20Email(user.email)

  return PHASE3_JULY20_APPRAISAL_NEEDED_ROLES.includes(role) ||
    PHASE3_JULY20_APPRAISAL_EMAILS.includes(email)
}

export const phase3July20CanViewAppraisalApproval = (user = {}) => {
  const role = normalizePhase3July20Role(user.role)
  const email = normalizePhase3July20Email(user.email)

  return PHASE3_JULY20_APPRAISAL_APPROVAL_ROLES.includes(role) ||
    PHASE3_JULY20_APPRAISAL_APPROVAL_EMAILS.includes(email)
}

export const phase3July20CanViewAllInventory = () => true
